import React from "react"
import PropTypes from 'prop-types'
import { Box, Text } from "@chakra-ui/react"

export function CareInformation({ productInformation, productType  }) {
  var productInfo = productInformation.nodes.filter(info => {
    return info.code === productType
  })
  return (
    <>
    {productInfo && productInfo[0] && 
    <Box
      id="careInfo"
    >
        {productInfo[0].careAndInfo.map((info, index) => (
          <Text as="h2" variant="productInfo"  key={`info-${index}`}>
            {info.detail}
         </Text>
        ))}       
    </Box>
    }
    </>
  )
}

CareInformation.propTypes = {
  productInformation: PropTypes.object.isRequired
}